<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <app-survey-frame-list>
      <app-survey-frame-tab-template
        #tabs
        [headerTemplate]="headerTemplate"
        [bodyTemplate]="bodyTemplate"
        [contexts]="contexts"
        headerWidth="30%"
        bodyWidth="65%"
      ></app-survey-frame-tab-template>
    </app-survey-frame-list>
  </div>
</div>
<ng-template #headerTemplate let-index="index" let-building="building">
  <div class="templateHeader building">
    <span class="building-key">
      <span class="bold landscape">
        <span i18n="@@general.units.building"> Building </span>
        {{ index + 1 }}
      </span>
      <span class="bold portrait">B{{ index + 1 }}</span>
      <span class="key" *ngIf="building?.lomKey">
        - {{ building?.lomKey }}
      </span>
    </span>
    <span class="address">{{
      building?.getMainAddress()?.getFullAddress()
    }}</span>
  </div>
</ng-template>
<ng-template #bodyTemplate let-index="index" let-building="building">
  <app-inside-survey-contact-info-form
    #contactForm
    [building]="building"
    [buildingId]="building.id"
    (updateContact)="onUpdateContact($event)"
    (removeContact)="onRemoveContact($event, building)"
    [address]="building.getMainAddress()"
    [index]="index + 1"
    [buildingIndex]="index + 1"
    [isAuthCanWrite]="isAuthCanWrite"
  ></app-inside-survey-contact-info-form>
</ng-template>
